import { LicenseInfo } from "@mui/x-license-pro"
import React from "react"

import { TableDrawer } from "../components/TableDrawer"
import { TableToolbar } from "../components/TableToolbar"

import { useTableContext } from "../provider"
import { TableComponent } from "./TableComponent"
import { LinearProgress, styled } from "@cirrus/ui-kit/src"
import { LifecycleState } from "../types"

LicenseInfo.setLicenseKey(
  "aa506eee1707a2d35f55fc499f89e0d8Tz00ODc0MSxFPTE2OTE1OTc2ODA5ODIsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=",
)

export const DataTable = () => {

  const ctx = useTableContext()

  return (
    <>
      {(ctx.props.enableDrawer) && <TableDrawer />}
      {(ctx.props.enableToolbar) && <TableToolbar />}
      {(ctx.props.isLoading || ctx.lifecycle.state < LifecycleState.Ready) && <LinearProgress />}
      <TableComponent />
      {ctx.props.legend}
    </>
  )
}
